import { FC } from 'react';
import { useIntl } from 'react-intl';

import { QuotedStatus } from '../status/quoted/Quoted';
import { Details } from './Details';
import type { QuotedSidePanelProps } from './Quoted.connect';
import { connectQuotedSidePanel } from './Quoted.connect';

const QuotedSidePanel: FC<QuotedSidePanelProps> = ({
  canTrade,
  isin,
  quotationType,
  quantity,
  tradeWay: tradeSide,
  cashAmount,
  settlementDate,
  accruedCoupon,
  tradeDate,
  upfrontFee,
  deductedFee,
  settlementPrice,
  price,
  onCancelTrade,
  onTrade,
  tradeAuthDurationInMillis,
  tradeAuthStartTimeInMillis,
  priceType,
  currency,
  quoteId,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="d-flex flex-column h-100 overflow-y-auto">
      {tradeAuthDurationInMillis !== undefined &&
        tradeAuthStartTimeInMillis !== undefined &&
        settlementPrice !== undefined && (
          <QuotedStatus
            price={settlementPrice}
            priceType={priceType}
            priceCurrency={currency}
            tradeAuthDurationInMillis={tradeAuthDurationInMillis}
            tradeAuthStartTimeInMillis={tradeAuthStartTimeInMillis}
          />
        )}
      <div className="h-100 flex-grow-1 d-flex flex-column m-2 overflow-y-auto">
        <Details
          isin={isin}
          quotationType={quotationType}
          quantity={quantity}
          tradeSide={tradeSide}
          cashAmount={cashAmount}
          settlementDate={settlementDate}
          accruedCoupon={accruedCoupon}
          tradeDate={tradeDate}
          upfrontFee={upfrontFee}
          deductedFee={deductedFee}
          quoteId={quoteId}
          settlementPrice={settlementPrice}
          price={price}
        />
      </div>
      <div className="d-flex flex-shrink-0 flex-column justify-content-end">
        <button
          onClick={onTrade}
          className="btn btn-xl btn-info m-1"
          disabled={!canTrade}
          data-e2e="btn-confirm-to-trade"
        >
          {formatMessage({ id: 'secondaryMarket.sidePanel.cta.confirmToTrade' })}
        </button>
        <button onClick={onCancelTrade} className="btn btn-xl btn-discreet-secondary m-1" data-e2e="btn-cancel">
          {formatMessage({ id: 'secondaryMarket.sidePanel.cta.cancel' })}
        </button>
      </div>
    </div>
  );
};

QuotedSidePanel.displayName = 'Component';

export const ConnectedQuotedSidePanel = connectQuotedSidePanel(QuotedSidePanel);

ConnectedQuotedSidePanel.displayName = 'ConnectedQuotedSidePanel';
